import { defineComponent } from "vue";
import LinkButton from "./component-library3.mjs";
import Paragraph from "./component-library5.mjs";
import NoAccessIcon from "./component-library483.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "gdpr-permission-layer",
  setup(__props, { expose }) {
    const onSettingsReset = () => {
      var _a, _b;
      if ((_b = (_a = window.utag) == null ? void 0 : _a.gdpr) == null ? void 0 : _b.showConsentPreferences) {
        window.utag.gdpr.showConsentPreferences();
      }
    };
    expose({ onSettingsReset });
    return { __sfc: true, onSettingsReset, LinkButton, Paragraph, NoAccessIcon };
  }
});
export {
  _sfc_main as default
};
